let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Qihf")).then(() => parcelRequire('jmyXj'));